// extracted by mini-css-extract-plugin
export default {"datepicker-space":"styles_datepicker-space__4dkj9","datepicker-space-buttons":"styles_datepicker-space-buttons__bhy0O"};